
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / invoice","xmlns":"http://www.w3.org/2000/svg","width":"25.127","height":"24","viewBox":"0 0 25.127 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M15.268 27.734l-2.547-1.273a.353.353 0 00-.319 0l-2.545 1.27a2.51 2.51 0 01-2.247 0l-2.548-1.27a.355.355 0 00-.159-.037.359.359 0 00-.159.037l-1.107.554a2.514 2.514 0 01-1.124.27 2.545 2.545 0 01-1.75-.712A2.482 2.482 0 010 24.769V3.949A3.954 3.954 0 013.949 0h17.23a3.953 3.953 0 013.948 3.949v20.82a2.507 2.507 0 01-3.636 2.246l-1.109-.554a.37.37 0 00-.162-.037.36.36 0 00-.16.037l-2.543 1.273a2.507 2.507 0 01-2.249 0zm-1.583-3.2l2.546 1.272a.354.354 0 00.162.039.345.345 0 00.16-.039l2.547-1.271a2.518 2.518 0 012.249 0l1.109.554a.349.349 0 00.16.039.36.36 0 00.361-.359V3.949a1.8 1.8 0 00-1.795-1.795H3.949a1.8 1.8 0 00-1.795 1.795v20.82a.359.359 0 00.358.359.349.349 0 00.16-.039l1.107-.554a2.515 2.515 0 012.247 0l2.547 1.273a.352.352 0 00.158.036.366.366 0 00.162-.037l2.545-1.272a2.515 2.515 0 012.247 0zm-6.864-5.15a1.077 1.077 0 01-.146-2.144l.146-.01h11.487a1.077 1.077 0 01.146 2.144l-.146.01zm0-5.385a1.077 1.077 0 01-.146-2.144l.146-.009h11.487a1.077 1.077 0 01.146 2.144l-.146.01zm0-5.384a1.077 1.077 0 01-.146-2.144l.146-.01h11.487a1.077 1.077 0 01.146 2.144l-.146.01z","fill":"#011936"}})])
          )
        }
      }
    